export default {
    store: null,
    stores: [],
    formType: 'contact',
    sent: false,
    sending: false,
    productId: null,
    availableMeetingForm: false,

    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
};
